<template>
<div class="modal-card" ref="element"> <!--style="width: auto">-->
  <header class="modal-card-head">
    <p class="modal-card-title">{{editEnabled ? "Edit Playlist" : "Add Playlist"}}</p>
  </header>
  <header class="modal-card-head" style="background-color:white;border-radius:0px;">
    <b-field label="Playlist Name:">
      <b-input type="text" v-model="name" placeholder="Playlist Name" :disabled="role === 'viewer'"></b-input>
    </b-field>
    <b-field v-if="bPlaylistError" style="color: red">
      Please enter a name.
    </b-field>
    </header>
  <section class="modal-card-body">
    <p style="margin-top:-10px">Playlist Items:</p>
    <b-table :mobile-cards="false" :data="tableData.length > 0 ? tableData : []" striped
      :draggable="role !== 'viewer'"
      @dragstart="dragstart"
      @drop="drop"
      @dragover="dragover"
      @dragleave="dragleave">

        <template slot-scope="props">
          <b-table-column centered>
            <b-icon icon="grip-vertical">
            </b-icon>
          </b-table-column>
          <b-table-column field="name" label="Name" centered>
            {{props.row.name}}
          </b-table-column>
          <b-table-column field="type" label="Type" centered>
            {{props.row.type.charAt(0).toUpperCase()+props.row.type.substring(1)}}
          </b-table-column>
          <b-table-column label="Edit/Remove/Copy" centered>
            <b-button type="is-info" icon-left="edit" @click="editItemModal(props.index)"></b-button>
            <b-button :disabled="role === 'viewer'" type="is-danger" icon-left="trash" @click="confirmRemoveItem(props.index, props.row.name, props.row.resourceName, props.row.resourceSize, props.row.isNew, props.row)"></b-button>
            <b-button :disabled="role === 'viewer'" type="is-success" icon-left="copy" @click="copyItem(props.row, props.row.resourceSize)"></b-button>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>No items to display.</p>
            </div>
          </section>
        </template>
      </b-table>
  </section>
  <footer class="modal-card-foot" style="background-color:white;border-radius:0px">
      <b-button type="is-success" icon-left="plus" @click="selectItemType" :disabled="role === 'viewer'">Add item</b-button>
      <p><b>No. of items: {{items.length}}</b></p>
  </footer>
  <footer class="modal-card-foot">
    <b-button type="is-info" @click="savePlaylist" v-if="editEnabled" :disabled="role === 'viewer'">Submit</b-button>
    <b-button type="is-info" icon-left="plus" @click="addPlaylist" v-else  :disabled="role === 'viewer'">Add new playlist</b-button>
    <b-button type="is-light" @click="closeModal()">Cancel</b-button>
  </footer>
</div>
</template>

<script>
import ItemAddEdit from '@/components/playlists/items/ItemAddEdit'
import ItemTypeSelect from '@/components/playlists/items/ItemTypeSelect'

export default {
  name: 'PlaylistAddEdit',
  props: ['editEnabled', 'propId', 'propParentFn'],
  data: () => {
    return {
      editStaticPlaylistRef: {},
      name: '',
      items: [],
      existingFileList: [],
      filesToRemove: [],
      playlistId: '',
      selectedItemType: '',
      tableData: [],
      draggingRow: null,
      draggingRowIndex: null,
      bPlaylistError: false,
      loadingComponent: null,
      filesToArchive: [],
      archiveItems: [],
      deleteFromBinItems: [],
      finishedUpload: false,
      finishedArchive: false,
      totalStorageSize: null,
      sizesPlus: 0,
      sizesMinus: 0,
      namesMinus: [],
      jsonResp: null,
      editedItemsLogs: [],
      oldPlaylistName: null,
      addedItemsLogs: [],
      addedItemsEditLogs: [],
      deletedItemsLogs: []
      // filesToKeep: []
    }
  },
  computed: {
    playlists () {
      return this.$store.state.playlists
    },
    menus () {
      return this.$store.state.menus
    },
    specialOffers () {
      return this.$store.state.specialOffers
    },
    playlistsArchive () {
      return this.$store.state.playlistsArchive
    },
    menusArchive () {
      return this.$store.state.menusArchive
    },
    specialOffersArchive () {
      return this.$store.state.specialOffersArchive
    },
    workspaceId () {
      return this.$store.state.workspaceId
    },
    role () {
      return this.$store.state.role
    },
    userId () {
      return this.$store.state.uid
    }
  },
  created: function () {
    fetch('https://api.seeip.org/geoip').then(
      (response) => response.json()
    ).then(
      (jsonResponse) => {
        this.jsonResp = jsonResponse
        this.globalLogger(this.jsonResp)
      }
    )
  },
  mounted: function () {
    // za logiranje
    if (this.editEnabled) {
      let id = this.propId
      this.editStaticPlaylistRef = Object.assign({}, this.$store.getters.getPlaylist(id))
      this.name = this.editStaticPlaylistRef.name
      this.oldPlaylistName = this.editStaticPlaylistRef.name
      this.playlistId = id
      if (this.editStaticPlaylistRef.items) {
        this.items = [...this.editStaticPlaylistRef.items.filter(x => x)]
        for (let i = 0; i < this.items.length; i++) {
          this.items[i].isNew = false
        }
      }
      let playlistFilesRef = null
      if (!this.getNotMigrated().includes(this.userId)) {
        playlistFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Playlists/' + id)
      } else {
        playlistFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Playlists/' + id)
      }
      playlistFilesRef.listAll().then((dir) => {
        dir.items.forEach(fileRef => {
          this.existingFileList.push(fileRef.name)
        })
      })
      this.globalLogger(this.existingFileList)
      for (let item in this.items) {
        this.tableData.push({ id: item, ...this.items[item] })
      }
      if (this.$store.state.playlistsArchive !== null) {
        this.archiveItems = this.$store.state.playlistsArchive.items
        this.globalLogger('playlists archive: ', this.archiveItems)
      }
    }
    this.refreshItemsTable()
  },
  methods: {
    refreshItemsTable () {
      this.tableData = []
      for (let item in this.items) {
        this.tableData.push({ id: item, ...this.items[item] })
      }
    },
    selectItemType () {
      if (this.role !== 'viewer') {
        this.$buefy.modal.open({
          parent: this,
          component: ItemTypeSelect,
          props: { selectFn: this.typeSelected },
          hasModalCard: true,
          trapFocus: true
        })
      }
    },
    typeSelected (type) {
      this.selectedItemType = type.toLowerCase()
      // this.globalLogger(this.selectedItemType)
      // this.bAddItem = true
      this.addItemModal(type.toLowerCase())
    },
    addItemModal (type) {
      this.$buefy.modal.open({
        parent: this,
        component: ItemAddEdit,
        props: { propType: type, propParentFn: this.receiveItemFromChild },
        hasModalCard: true,
        trapFocus: true,
        canCancel: ['x']
      })
    },
    receiveItemFromChild (item, delBinItem, sizeOfRes, nameOfRes, sMinus) {
      this.globalLogger('rec item from child')
      item.isNew = true
      item.resourceName = nameOfRes

      if (this.editEnabled) {
        // var log = { ip_addr: this.jsonResp.ip, city: this.jsonResp.city, playlistId: this.propId, type: item.type, userId: item.userId }
        var logItem = null
        if (item.type === 'url' || item.type === 'youtube' || (item.type === 'clock' && (item.resourceName === undefined || item.resourceName === '' || item.resourceName === null)) || (item.type === 'arrivals' && (item.resourceName === undefined || item.resourceName === '' || item.resourceName === null)) || (item.type === 'departures' && (item.resourceName === undefined || item.resourceName === '' || item.resourceName === null)) || (item.type === 'weather' && (item.resourceName === undefined || item.resourceName === '' || item.resourceName === null)) || (item.type === 'airquality' && (item.resourceName === undefined || item.resourceName === '' || item.resourceName === null)) || (item.type === 'rates' && (item.resourceName === undefined || item.resourceName === '' || item.resourceName === null))) {
          logItem = Object.assign({}, item)
          logItem.ip_addr = this.jsonResp ? this.jsonResp.ip : ''
          logItem.city = this.jsonResp ? this.jsonResp.city : ''
          this.addedItemsEditLogs.push(logItem)
          // this.$analytics.logEvent('add_item', logItem)
        }
      }

      if (sizeOfRes !== undefined && sizeOfRes !== null && nameOfRes !== undefined && nameOfRes !== null) {
        let znameZ = true
        this.globalLogger('this.items', this.items)
        for (let z = 0; z < this.items.length; z++) {
          if (this.items[z].resourceName === nameOfRes && this.items[z].resourceSize === sizeOfRes) { // dali istiot resurs vekje se koristi od drug item
            znameZ = false
            this.globalLogger('uslov za zname false')
          } else if (this.items[z].resourceName === nameOfRes) { // dali resurs so isto ime vekje se koristi
            let znameM = true
            for (let u = 0; u < this.namesMinus.length; u++) {
              if (this.namesMinus[u] === this.items[z].resourceName) {
                znameM = false
                this.globalLogger('znameM e false')
              }
            }
            if (znameM) {
              this.globalLogger('znameM e true')
              this.namesMinus.push(this.items[z].resourceName)
              this.sizesMinus += this.items[z].resourceSize
            }
            this.globalLogger('sizes Minus vo uslov')
          }
        }
        if (znameZ) {
          this.globalLogger('zname e true')
          this.sizesPlus += sizeOfRes
        }
        this.globalLogger('sizesPlus: ', this.sizesPlus)
      }

      this.items.push(item)

      this.globalLogger(this.items, 'vo receive')

      if (delBinItem !== undefined && delBinItem !== null) {
        if (this.deleteFromBinItems === null) {
          this.deleteFromBinItems = []
        }
        var flag = 1
        for (let i = 0; i < this.deleteFromBinItems.length; i++) {
          if (this.deleteFromBinItems[i] === delBinItem) {
            flag = 0
          }
        }
        if (flag === 1) {
          this.deleteFromBinItems.push(delBinItem)
        }
        this.globalLogger('delete from bin itemS in receive playlists: ', this.deleteFromBinItems)
      }
      // proverka dali ima dr item so resurs so isto ime, bidejki ke se prezapise, pa ako i size kaj noviot resurs e razlicno,
      // treba da se updatira resourceSize kaj stariot item
      for (let itemId in this.items) {
        this.globalLogger(this.items[itemId], 'item[itemid')
        if (this.items[itemId].resourceName === nameOfRes && this.items[itemId].resourceSize !== sizeOfRes) {
          this.globalLogger('USLOV')
          this.items[itemId].resourceSize = sizeOfRes
        }
      }
      // kraj na proverka

      // ako e uploadirano od bin
      if (sMinus !== null && sMinus !== undefined) {
        this.globalLogger('sMinus ne e null')
        this.sizesMinus += sMinus
      }
      this.refreshItemsTable()
    },
    confirmRemoveItem (id, itemName, fileN, fileSize, isNew, remItem) {
      if (this.role !== 'viewer') {
        this.globalLogger(id, fileN)
        this.globalLogger('fileSize: ', fileSize)
        this.$buefy.dialog.confirm({
          message: 'Do you want to <b>delete</b> item "' + itemName + '"?',
          confirmText: 'Delete',
          type: 'is-danger',
          onConfirm: () => {
            if (this.editEnabled) {
            // var log = { ip_addr: this.jsonResp.ip, city: this.jsonResp.city, playlistId: this.propId, type: item.type, userId: item.userId }
              var logItemDel = Object.assign({}, remItem)
              logItemDel.ip_addr = this.jsonResp ? this.jsonResp.ip : ''
              logItemDel.city = this.jsonResp ? this.jsonResp.city : ''
              this.deletedItemsLogs.push(logItemDel)
            }

            var isUsed = false
            var brojac = 0
            this.items = this.items.filter((x) => { return this.items.indexOf(x) !== parseInt(id) })
            if (fileN !== '' && fileN !== undefined) {
              for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].resourceName === fileN) {
                  this.globalLogger('is used is true', fileN)
                  brojac++
                  isUsed = true
                }
              }
            }
            if (isUsed && !isNew) {
              var mess = null
              if (brojac > 1) {
                mess = 'The resource "' + fileN + '" is also used by other items and will remain in the playlist.'
                // this.$buefy.dialog.alert('The resource "' + fileN + '" is being used by other items and will remain in the playlist.')
              } else {
                mess = 'The resource "' + fileN + '" is also used by another item and will remain in the playlist.'
              }
              this.$buefy.toast.open({
                duration: 8000,
                message: mess
              })
              this.refreshItemsTable()
            } else if (isNew || fileN === '' || fileN === undefined) {
              if (fileN !== '' && fileN !== undefined) {
                this.globalLogger('new e')
                this.items = this.items.filter((x) => { return this.items.indexOf(x) !== parseInt(id) })
                var fff = true
                for (let d = 0; d < this.items.length; d++) {
                  if (this.items[d].resourceName === fileN && this.items[d].resourceSize === fileSize) { // dali go ima drug item toj resurs
                    fff = false
                  }
                }
                if (fff) {
                  this.globalLogger('fff e true')
                  this.sizesMinus += fileSize
                  this.globalLogger('sizes Minus', this.sizesMinus)
                }
              } // else {
              // this.items = this.items.filter((x) => { return this.items.indexOf(x) !== parseInt(id) })
              // }
              this.refreshItemsTable()

              // this.items = this.items.filter((x) => { return this.items.indexOf(x) !== parseInt(id) })
              // this.refreshItemsTable()
            } else {
              this.$buefy.dialog.confirm({
                message: 'Do you also want to delete the resource associated with this item ("' + fileN + '")?',
                cancelText: 'Archive resource',
                confirmText: 'Delete forever',
                type: 'is-danger',
                onConfirm: () => {
                  let ff = true
                  for (let t = 0; t < this.items.length; t++) {
                    if (this.items[t].resourceName === fileN && this.items[t].resourceSize === fileSize) { // dali go ima drug item toj resurs
                      ff = false
                    }
                  }
                  if (ff) {
                    this.globalLogger('ff e true')
                    this.sizesMinus += fileSize
                  }
                  this.globalLogger('sizesMinus vo delete item', this.sizesMinus)
                  this.$buefy.toast.open({
                    duration: 3000,
                    message: 'The changes will take effect on submit.'
                  })
                },
                onCancel: () => {
                  this.filesToArchive.push({ 'resName': fileN, 'resSize': fileSize })
                  this.$buefy.toast.open({
                    duration: 3000,
                    message: 'The changes will take effect on submit.'
                  })
                }
              })
              // this.items = this.items.filter((x) => { return this.items.indexOf(x) !== parseInt(id) })
              this.refreshItemsTable()
            }
          }
        })
      }
    },
    copyItem (item, resSize) {
      if (this.role !== 'viewer') {
        item.isNew = true
        if (resSize !== undefined) {
          item.resourceSize = resSize
        }

        if (this.editEnabled) {
          // var log = { ip_addr: this.jsonResp.ip, city: this.jsonResp.city, playlistId: this.propId, type: item.type, userId: item.userId }
          var logItem = null
          if (item.type === 'url' || item.type === 'youtube' || (item.type === 'clock' && (item.resourceName === undefined || item.resourceName === '' || item.resourceName === null)) || (item.type === 'arrivals' && (item.resourceName === undefined || item.resourceName === '' || item.resourceName === null)) || (item.type === 'departures' && (item.resourceName === undefined || item.resourceName === '' || item.resourceName === null)) || (item.type === 'weather' && (item.resourceName === undefined || item.resourceName === '' || item.resourceName === null)) || (item.type === 'airquality' && (item.resourceName === undefined || item.resourceName === '' || item.resourceName === null)) || (item.type === 'rates' && (item.resourceName === undefined || item.resourceName === '' || item.resourceName === null))) {
            logItem = Object.assign({}, item)
            logItem.ip_addr = this.jsonResp ? this.jsonResp.ip : ''
            logItem.city = this.jsonResp ? this.jsonResp.city : ''
            this.addedItemsEditLogs.push(logItem)
            // this.$analytics.logEvent('add_item', logItem)
          }
        }
        this.globalLogger('ITEM: ', item)
        this.items.push(item)
        this.globalLogger('this.items in copy: ', this.items)
        this.refreshItemsTable()
      }
    },
    editItemModal (id) {
      this.globalLogger('this.items: ', this.items)
      this.$buefy.modal.open({
        parent: this,
        component: ItemAddEdit,
        props: { propItem: this.items[id], propId: id, propParentFn: this.updateItemFromChild, playlId: this.propId },
        hasModalCard: true,
        trapFocus: true,
        canCancel: ['x']
      })
    },
    updateItemFromChild (item, oldItem, id, toRemove, toArchive, delBinItem, sizeOfRes, nameOfRes, sizeOfResOld, nameOfResOld, sizeMin) {
      this.globalLogger('update item from child')
      this.globalLogger('old item', oldItem)
      this.globalLogger('new item', item)
      if (this.editEnabled) {
        var log = { ip_addr: this.jsonResp ? this.jsonResp.ip : '', city: this.jsonResp ? this.jsonResp.city : '', playlistId: oldItem.playlistId, type: item.type, userId: item.userId }
        if (item.name !== oldItem.name) {
          log.oldName = oldItem.name
          log.newName = item.name
        } else {
          log.name = item.name
        }
        if (item.description !== oldItem.description) {
          log.oldDescription = oldItem.description
          log.newDescription = item.description
        }
        if (item.effect !== oldItem.effect) {
          log.oldEffect = oldItem.effect
          log.newEffect = item.effect
        }
        if (item.type === 'image') {
          if (item.imageDuration !== oldItem.imageDuration) {
            log.oldImageDuration = oldItem.imageDuration
            log.newImageDuration = item.imageDuration
          }
        } if (item.type === 'pdf') {
          if (item.pdfDuration !== oldItem.pdfDuration) {
            log.oldPdfDuration = oldItem.pdfDuration
            log.newPdfDuration = item.pdfDuration
          }
        } else if (item.type === 'url') {
          if (item.url !== oldItem.url) {
            log.oldUrl = oldItem.url
            log.newUrl = item.url
          }
          if (item.urlDuration !== oldItem.urlDuration) {
            log.oldUrlDuration = oldItem.urlDuration
            log.newUrlDuration = item.urlDuration
          }
        } else if (item.type === 'airquality') {
          if (item.airQualityDuration !== oldItem.airQualityDuration) {
            log.oldAirQualityDuration = oldItem.airQualityDuration
            log.newAirQualityDuration = item.airQualityDuration
          }
          if (item.pollutionType !== oldItem.pollutionType) {
            log.oldPollutionType = oldItem.pollutionType
            log.newPollutionType = item.pollutionType
          }
        } else if (item.type === 'rates') {
          if (item.ratesDuration !== oldItem.ratesDuration) {
            log.oldRatesDuration = oldItem.ratesDuration
            log.newRatesDuration = item.ratesDuration
          }
          if (item.ratesSource !== oldItem.ratesSource) {
            log.oldRatesSource = oldItem.ratesSource
            log.newRatesSource = item.ratesSource
          }
        } else if (item.type === 'youtube') {
          if (item.youtubeUrl !== oldItem.youtubeUrl) {
            log.oldYoutubeUrl = oldItem.youtubeUrl
            log.newYoutubeUrl = item.youtubeUrl
          }
        } else if (item.type === 'arrivals' || item.type === 'departures') {
          if (item.code !== oldItem.code) {
            log.oldCode = oldItem.code
            log.newCode = item.code
          }
          if (item.duration !== oldItem.duration) {
            log.oldDuration = oldItem.duration
            log.newDuration = item.duration
          }
        } else if (item.type === 'clock') {
          if (item.duration !== oldItem.duration) {
            log.oldDuration = oldItem.duration
            log.newDuration = item.duration
          }
        } else if (item.type === 'weather') {
          if (item.cityID !== oldItem.cityID) {
            log.oldCityID = oldItem.cityID
            log.newCityID = item.cityID
          }
          if (item.weatherDuration !== oldItem.weatherDuration) {
            log.oldWeatherDuration = oldItem.weatherDuration
            log.newWeatherDuration = item.weatherDuration
          }
        }
        // var fl = false
        if (item.file) {
          // ako se menuva postoecka slika
          if (oldItem.resourceName && oldItem.resourceSize && item.file.name !== oldItem.resourceName && item.file.size !== oldItem.resourceSize) {
            this.globalLogger('se menuva postoecka slika')
            log.oldResourceName = oldItem.resourceName
            log.oldResourceSize = oldItem.resourceSize
            log.newResourceName = item.file.name
            log.newResourceSize = item.file.size
            // this.editedResourceItemsLogs.push(log)
            // fl = true
          } else if (!oldItem.resourceName) {
            this.globalLogger('se dodava slika (prethodno nemalo)')
            log.newResourceName = item.file.name
            log.newResourceSize = item.file.size
            // this.editedResourceItemsLogs.push(log)
            // fl = true
          }
        }
        // if (!fl) {
        this.editedItemsLogs.push(log)
        // }
        this.globalLogger('log: ', log)
      }
      this.items[id] = item
      if (toRemove !== undefined) {
        if (toRemove.length > 0) {
          for (let i = 0; i < toRemove.length; i++) {
            this.filesToRemove.push(toRemove[i])
            this.globalLogger(toRemove[i])
          }
        }
      }
      if (toArchive !== undefined) {
        if (toArchive.length > 0) {
          for (let i = 0; i < toArchive.length; i++) {
            this.filesToArchive.push(toArchive[i])
            this.filesToRemove.push(toArchive[i].resName)
            this.globalLogger(toArchive[i])
          }
        }
      }
      this.globalLogger('update del')

      if (sizeOfRes !== undefined && sizeOfRes !== null && nameOfRes !== undefined && nameOfRes !== null) {
        let znameZZ = true
        this.globalLogger('this.items', this.items)
        for (let z = 0; z < this.items.length; z++) {
          if (this.items[z].resourceName === nameOfRes && this.items[z].resourceSize === sizeOfRes) { // dali istiot resurs vekje se koristi od drug item
            znameZZ = false
            this.globalLogger('uslov za zname false')
          } else if (this.items[z].resourceName === nameOfRes) { // dali resurs so isto ime vekje se koristi
            let znameM = true
            for (let u = 0; u < this.namesMinus.length; u++) {
              if (this.namesMinus[u] === this.items[z].resourceName) {
                znameM = false
                this.globalLogger('znameM', ' e false')
              }
            }
            if (znameM) {
              this.globalLogger('znameM', 'e true')
              this.namesMinus.push(this.items[z].resourceName)
              this.sizesMinus += this.items[z].resourceSize
            }
            this.globalLogger('sizes Minus', 'vo uslov')
          }
        }
        if (znameZZ) {
          this.globalLogger('zname e true')
          this.sizesPlus += sizeOfRes
        }
        this.globalLogger('sizesPlus: ', this.sizesPlus)
      }

      if (sizeOfResOld !== undefined && sizeOfResOld !== null && nameOfResOld !== undefined && nameOfResOld !== null) {
        let znameN = true
        for (let m = 0; m < this.items.length; m++) {
          if (this.items[m].resourceName === nameOfResOld && this.items[m].resourceSize === sizeOfResOld) { // dali istiot resurs vekje se koristi od drug item
            znameN = false
          }
        }
        if (znameN) {
          let znameNN = true
          for (let o = 0; o < this.namesMinus.length; o++) {
            if (this.namesMinus[o] === nameOfResOld) {
              znameNN = false
              this.globalLogger('znameNN e false')
            }
          }
          if (znameNN) {
            this.globalLogger('znameNN e true')
            this.sizesMinus += sizeOfResOld
            this.globalLogger(this.sizesMinus)
          }
        }
      }

      if (delBinItem !== undefined && delBinItem !== null) {
        if (this.deleteFromBinItems === null) {
          this.deleteFromBinItems = []
        }
        var flag = 1
        for (let i = 0; i < this.deleteFromBinItems.length; i++) {
          if (this.deleteFromBinItems[i] === delBinItem) {
            flag = 0
          }
        }
        if (flag === 1) {
          this.deleteFromBinItems.push(delBinItem)
        }
        this.globalLogger('delete from bin itemS: ', this.deleteFromBinItems)
      }

      if (sizeMin !== null && sizeMin !== undefined) {
        this.globalLogger('sizeMin ne e null')
        this.sizesMinus += sizeMin
      }
      this.refreshItemsTable()
    },
    addPlaylist () {
      if (this.role !== 'viewer') {
        if (this.name === '') {
          this.bPlaylistError = true
        } else if (this.storageAvailable()) {
          this.globalLogger('this.storageAvailable finished')
          this.loadingComponent = this.$buefy.loading.open({
            container: this.$refs.element.$el
          })
          let newPlaylistRef = null
          if (!this.getNotMigrated().includes(this.userId)) {
            newPlaylistRef = this.$store.state.database.ref('/neoslide/playlists/' + this.workspaceId).push()
          } else {
            newPlaylistRef = this.$store.state.database.ref('/playlists/' + this.userId).push()
          }
          this.playlistId = newPlaylistRef['key']
          for (let itemId in this.items) {
            this.items[itemId].playlistId = this.playlistId
            this.items[itemId].id = itemId
          }
          // za logiranje
          this.$analytics.logEvent('add_playlist', {
            name: this.name,
            ip_addr: this.jsonResp ? this.jsonResp.ip : '',
            city: this.jsonResp ? this.jsonResp.city : ''
          })
          // -- za logiranje
          newPlaylistRef.set({
            name: this.name,
            // items: this.items,
            userId: this.$store.state.uid
          }).then(() => {
            this.removeUnusedFiles(true)
            // this.submitFiles()
            // this.closeModal()
          })
        } else {
          this.$buefy.dialog.confirm({
            title: 'Storage full',
            message: 'The upload cannot be done because you have used up your available storage.',
            hasIcon: true,
            confirmText: 'OK',
            type: 'is-danger'
          })
        }
      }
    },
    savePlaylist () {
      if (this.role !== 'viewer') {
        if (this.name === '') {
          this.bPlaylistError = true
        } else if (this.storageAvailable()) {
          this.loadingComponent = this.$buefy.loading.open({
            container: this.$refs.element.$el
          })
          let id = this.playlistId
          this.globalLogger('/playlists/' + this.$store.state.uid + '/' + id)
          let editPlaylistRef = null
          if (!this.getNotMigrated().includes(this.userId)) {
            editPlaylistRef = this.$store.state.database.ref('/neoslide/playlists/' + this.workspaceId + '/' + id)
          } else {
            editPlaylistRef = this.$store.state.database.ref('/playlists/' + this.userId + '/' + id)
          }
          for (let itemId in this.items) {
            this.items[itemId].playlistId = id
            this.items[itemId].id = itemId
          }
          // za logiranje
          var plObject = {
            name: this.name,
            ip_addr: this.jsonResp ? this.jsonResp.ip : '',
            city: this.jsonResp ? this.jsonResp.city : ''
          }
          if (this.name !== this.oldPlaylistName) {
            plObject.oldName = this.oldPlaylistName
          }
          this.$analytics.logEvent('edit_playlist', plObject)
          // -- za logiranje
          editPlaylistRef.update({
            name: this.name
            // items: this.items
          }, () => {
            this.removeUnusedFiles(false)
            // this.closeModal()
          })
        } else {
          this.$buefy.dialog.confirm({
            title: 'Storage full',
            message: 'The upload cannot be done because you have used up your available storage.',
            hasIcon: true,
            confirmText: 'OK',
            type: 'is-danger'
          })
        }
      }
    },
    removeUnusedFiles (isAdd) {
      this.globalLogger('remove unused', isAdd)
      for (let fileName of this.existingFileList) {
        let isReferenced = false
        for (let item of this.items) {
          if (item.resourceName === fileName) {
            isReferenced = true
            break
          }
        }
        if (!isReferenced) {
          this.filesToRemove.push(fileName)
        }
      }
      this.filesToRemove = [...new Set(this.filesToRemove)]
      if (this.filesToRemove.length === 0) {
        this.globalLogger('Nothing to remove')
      } else {
        this.globalLogger('files to remove', this.filesToRemove)
      }

      this.globalLogger('items: ', this.deleteFromBinItems)
      if (this.deleteFromBinItems.length > 0) {
        let deleteBinPromiseList = []
        this.globalLogger('brisenje od bin')
        var removePlaylistFilesRef = null
        if (!this.getNotMigrated().includes(this.userId)) {
          removePlaylistFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/PlaylistsArchive/')
        } else {
          removePlaylistFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/PlaylistsArchive/')
        }
        removePlaylistFilesRef.listAll().then(dir => {
          dir.items.forEach(fileRef => {
            if (this.deleteFromBinItems.includes(fileRef.name)) {
              this.globalLogger('removing file ', fileRef.name)
              deleteBinPromiseList.push(fileRef.delete())
            }
          })
        }).finally(() => {
          Promise.all(deleteBinPromiseList).then(() => {
            this.globalLogger('then')
            let itemsDel = this.$store.state.playlistsArchive.items
            if (itemsDel !== null) {
              this.globalLogger('files to Delete: ', this.deleteFromBinItems)
              var binItems = this.$store.state.playlistsArchive.items
              this.globalLogger('binItems before: ', binItems)
              for (let i = 0; i < this.deleteFromBinItems.length; i++) {
                binItems = binItems.filter(c => c.resName !== this.deleteFromBinItems[i])
              }
              this.globalLogger('binItems after: ', binItems)
              if (!this.getNotMigrated().includes(this.userId)) {
                this.$store.state.database.ref('/neoslide/archive/' + this.workspaceId + '/playlists/').update({
                  items: binItems
                })
              } else {
                this.$store.state.database.ref('/archive/' + this.userId + '/playlists/').update({
                  items: binItems
                })
              }
            }
            // this.$parent.close()
            this.globalLogger('prvo')
            // this.loadingComponent.close()
          })
        })
      }

      if (this.filesToArchive.length !== 0) {
        var flag = 0

        var count1 = 0
        var archiveItemsCopy = []
        for (let z = 0; z < this.archiveItems.length; z++) {
          archiveItemsCopy[z] = this.archiveItems[z]
        }
        // var archiveItemsCopy = this.archiveItems
        for (let x = 0; x < this.filesToArchive.length; x++) {
          var znak = 1
          for (let y = 0; y < archiveItemsCopy.length; y++) {
            if (archiveItemsCopy[y].resName === this.filesToArchive[x].resName && archiveItemsCopy[y].resSize === this.filesToArchive[x].resSize) {
              this.globalLogger('znak e 0')
              znak = 0
            } else if (archiveItemsCopy[y].resName === this.filesToArchive[x].resName) {
              this.globalLogger('samo imeto')
              archiveItemsCopy = archiveItemsCopy.filter(x => x.resName !== this.filesToArchive[x].resName)
            }
          }
          if (znak === 1) {
            count1++
            archiveItemsCopy.push(this.filesToArchive[x])
          }
          this.globalLogger('files to archive ', this.filesToArchive[x])
        }
        this.globalLogger('arch items copy length: ', archiveItemsCopy.length)
        this.globalLogger('this.archiveItems length', this.archiveItems.length)

        // this.callDownloadArchiveFiles(this.filesToArchive)

        var count2 = 0
        for (let i = 0; i < this.filesToArchive.length; i++) {
          this.globalLogger('file to archive', this.filesToArchive[i])
          let fileRef = null
          if (!this.getNotMigrated().includes(this.userId)) {
            fileRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Playlists/' + this.playlistId + '/' + this.filesToArchive[i].resName)
          } else {
            fileRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Playlists/' + this.playlistId + '/' + this.filesToArchive[i].resName)
          }
          fileRef.getDownloadURL().then((url) => {
            this.globalLogger('HERE', url)
            const xhr = new XMLHttpRequest()
            xhr.responseType = 'blob'
            xhr.onload = (event) => {
              const blob = xhr.response
              var file = new File([blob], fileRef.name, {type: blob.type})
              this.globalLogger('file1', file)
              let ref = null
              if (!this.getNotMigrated().includes(this.userId)) {
                ref = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/PlaylistsArchive/' + fileRef.name)
              } else {
                ref = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/PlaylistsArchive/' + fileRef.name)
              }
              ref.put(file).then((snapshot) => {
                this.globalLogger('snapshot', snapshot)
                ref.getDownloadURL().then((url) => {
                  this.globalLogger('file2', file)
                  var zn = 1
                  for (let j = 0; j < this.archiveItems.length; j++) {
                    if (this.archiveItems[j].resName === file.name && this.archiveItems[j].resSize === file.size) {
                      this.globalLogger('zn e 0')
                      zn = 0
                    } else if (this.archiveItems[j].resName === file.name) {
                      this.globalLogger('samo imeto')
                      this.archiveItems = this.archiveItems.filter(x => x.resName !== file.name)
                    }
                  }
                  if (zn === 1) {
                    count2++
                    this.globalLogger(count2, 'count2')
                    this.globalLogger('zn e 1')
                    this.archiveItems.push({ 'resName': file.name, 'resSize': file.size })
                  }
                  this.globalLogger('File ' + file.name + ' successfully uploaded at ' + url)
                }).finally(() => {
                  this.globalLogger('finally new', this.archiveItems)
                  if (this.deleteFromBinItems.length > 0) {
                    for (let i = 0; i < this.deleteFromBinItems.length; i++) {
                      this.archiveItems = this.archiveItems.filter(c => c.resName !== this.deleteFromBinItems[i])
                    }
                  }
                  if (!this.getNotMigrated().includes(this.userId)) {
                    this.$store.state.database.ref('/neoslide/archive/' + this.workspaceId + '/playlists/').update({
                      items: this.archiveItems
                    })
                  } else {
                    this.$store.state.database.ref('/archive/' + this.userId + '/playlists/').update({
                      items: this.archiveItems
                    })
                  }
                  if (flag === 0) {
                    this.globalLogger('FLAG = 0')

                    let deletePromiseList = []

                    let removePlaylistFilesRef = null
                    if (!this.getNotMigrated().includes(this.userId)) {
                      removePlaylistFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Playlists/' + this.playlistId)
                    } else {
                      removePlaylistFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Playlists/' + this.playlistId)
                    }
                    removePlaylistFilesRef.listAll().then(dir => {
                      dir.items.forEach(fileRef => {
                        if (this.filesToRemove.includes(fileRef.name)) {
                          this.globalLogger('removing file ', fileRef.name)
                          deletePromiseList.push(fileRef.delete())
                        }
                      })
                    })
                    Promise.all(deletePromiseList).then(() => {
                      this.submitFiles(isAdd)
                    })
                  }
                  flag = 1
                }).finally(() => {
                  this.globalLogger('second finally')
                  this.globalLogger(count1, count2)
                  if (count1 === count2) {
                    this.finishedArchive = true
                    // proverka
                    let brojac = 0
                    let fileList1 = []
                    for (let itemId in this.items) {
                      if (this.items[itemId].file) {
                        fileList1.push(this.items[itemId].file)
                      }
                    }
                    let uniqueFiles1 = []
                    for (let file of fileList1) {
                      let isPresent1 = false
                      for (let otherFile of uniqueFiles1) {
                        if (file.name === otherFile.name) {
                          isPresent1 = true
                          break
                        }
                      }
                      if (!isPresent1) {
                        uniqueFiles1.push(file)
                        brojac++
                      }
                    }
                    // brojac e 0 -> nema za upload
                    if (brojac === 0) {
                      this.globalLogger('brojac e 0')
                      this.closeModal()
                      this.loadingComponent.close()
                    } else if (this.finishedUpload) {
                      this.globalLogger('finished upload e true vo archive')
                      this.closeModal()
                      this.loadingComponent.close()
                    }
                    // proverka
                  }
                })
              }).catch(error => {
                this.globalLogger('Submit files error: ', error)
              })
            }
            xhr.open('GET', url)
            this.globalLogger('url', url)
            xhr.send()
          }).catch((error) => {
            this.globalLogger('error', error)
          }).finally(() => {
            this.globalLogger('finally old')
          })
        }
      } else {
        let deletePromiseList = []
        if (!this.getNotMigrated().includes(this.userId)) {
          removePlaylistFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Playlists/' + this.playlistId)
        } else {
          removePlaylistFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Playlists/' + this.playlistId)
        }
        removePlaylistFilesRef.listAll().then(dir => {
          dir.items.forEach(fileRef => {
            if (this.filesToRemove.includes(fileRef.name)) {
              this.globalLogger('removing file ', fileRef.name)
              deletePromiseList.push(fileRef.delete())
            }
          })
        })
        Promise.all(deletePromiseList).then(() => {
          this.submitFiles(isAdd)
        })
      }
    },
    submitFiles (isAdd) {
      let fileList = []
      for (let itemId in this.items) {
        if (this.items[itemId].file) {
          fileList.push(this.items[itemId].file)
        }
      }

      if (fileList.length === 0) {
        this.globalLogger('Nothing to upload')
        if (!this.getNotMigrated().includes(this.userId)) {
          this.$store.state.database.ref('/neoslide/playlists/' + this.workspaceId + '/' + this.playlistId).update({
            items: this.items
          })
        } else {
          this.$store.state.database.ref('/playlists/' + this.userId + '/' + this.playlistId).update({
            items: this.items
          })
        }
        var logItem = null
        if (isAdd) {
          for (let item in this.items) {
            logItem = Object.assign({}, this.items[item])
            logItem.ip_addr = this.jsonResp ? this.jsonResp.ip : ''
            logItem.city = this.jsonResp ? this.jsonResp.city : ''
            this.$analytics.logEvent('add_item', logItem)
          }
        } else {
          if (this.editedItemsLogs.length > 0) {
            for (let editLog in this.editedItemsLogs) {
              this.globalLogger('edit log: ', this.editedItemsLogs[editLog])
              this.$analytics.logEvent('edit_item', this.editedItemsLogs[editLog])
            }
          }
          if (this.addedItemsEditLogs.length > 0) {
            for (let addLog in this.addedItemsEditLogs) {
              this.globalLogger('add log: ', this.addedItemsEditLogs[addLog])
              this.$analytics.logEvent('add_item_edit_pl', this.addedItemsEditLogs[addLog])
            }
          }
          for (let deleteLog in this.deletedItemsLogs) {
            this.globalLogger('NEMA ZA UPLOAD')
            this.globalLogger('delete log: ', this.deletedItemsLogs[deleteLog])
            this.$analytics.logEvent('delete_item', this.deletedItemsLogs[deleteLog])
          }
        }
        if (this.filesToArchive.length === 0) {
          this.closeModal()
          this.loadingComponent.close()
          this.globalLogger('vtoro')
        }
      } else {
        // proverka dali ima nekoi itemi koi nemaat resursi, za tie da se napravi zapis vo google cloud
        if (isAdd) {
          for (let item in this.items) {
            var itm = this.items[item]
            this.globalLogger(itm.resourceName, 'RES NAME')
            if (itm.type === 'url' || itm.type === 'youtube' || (itm.type === 'clock' && (itm.resourceName === undefined || itm.resourceName === '' || itm.resourceName === null)) || (itm.type === 'arrivals' && (itm.resourceName === undefined || itm.resourceName === '' || itm.resourceName === null)) || (itm.type === 'departures' && (itm.resourceName === undefined || itm.resourceName === '' || itm.resourceName === null)) || (itm.type === 'weather' && (itm.resourceName === undefined || itm.resourceName === '' || itm.resourceName === null)) || (itm.type === 'airquality' && (itm.resourceName === undefined || itm.resourceName === '' || itm.resourceName === null)) || (itm.type === 'rates' && (itm.resourceName === undefined || itm.resourceName === '' || itm.resourceName === null))) {
              logItem = Object.assign({}, itm)
              logItem.ip_addr = this.jsonResp ? this.jsonResp.ip : ''
              logItem.city = this.jsonResp ? this.jsonResp.city : ''
              this.addedItemsLogs.push(logItem)
              // this.$analytics.logEvent('add_item', logItem)
            }
          }
        }
      }

      let uniqueFiles = []

      for (let file of fileList) {
        let isPresent = false
        for (let otherFile of uniqueFiles) {
          if (file.name === otherFile.name) {
            isPresent = true
            break
          }
        }
        if (!isPresent) {
          uniqueFiles.push(file)
        }
      }

      let counter = 0

      // this.callUploadFiles(uniqueFiles)

      for (let f of uniqueFiles) {
        this.globalLogger('unique files ', uniqueFiles)
        let ref = null
        if (!this.getNotMigrated().includes(this.userId)) {
          ref = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Playlists/' + this.playlistId + '/' + f.name)
        } else {
          ref = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Playlists/' + this.playlistId + '/' + f.name)
        }
        this.globalLogger('F', f)
        ref.put(f).then((snapshot) => {
          ref.getDownloadURL().then((url) => {
            this.globalLogger('File ' + f.name + ' successfully uploaded at ' + url)
            for (let id in this.items) {
              this.globalLogger(this.items, 'ITEMS')
              if ((this.items[id].file && this.items[id].file.name === f.name) || this.items[id].resourceName === f.name) {
                this.globalLogger('entered')
                this.globalLogger(this.items[id].file, this.items[id].file.name, f.name, this.items[id].resourceName)
                this.items[id].resourceName = f.name
                this.globalLogger('TYPE', this.items[id].type)
                if (this.items[id].type === 'video') {
                  this.items[id].videoUrl = url
                } else if (this.items[id].type === 'weather') {
                  this.items[id].weatherImageUrl = ''
                  this.items[id].imageUrl = url
                } else if (this.items[id].type === 'pdf') {
                  this.items[id].pdfUrl = url
                } else {
                  this.items[id].imageUrl = url
                  this.globalLogger('imageUrl', this.items[id].imageUrl)
                }
                var logItem = Object.assign({}, this.items[id])
                logItem.ip_addr = this.jsonResp ? this.jsonResp.ip : ''
                logItem.city = this.jsonResp ? this.jsonResp.city : ''
                if (isAdd) {
                  this.addedItemsLogs.push(logItem)
                  // this.$analytics.logEvent('add_item', logItem)
                } else {
                  this.addedItemsEditLogs.push(logItem)
                }
              }
            }
            counter++
          }).finally(() => {
            this.globalLogger('FINALLY ok', this.items)
            if (!this.getNotMigrated().includes(this.userId)) {
              this.$store.state.database.ref('/neoslide/playlists/' + this.workspaceId + '/' + this.playlistId).update({
                items: this.items
              })
            } else {
              this.$store.state.database.ref('/playlists/' + this.userId + '/' + this.playlistId).update({
                items: this.items
              })
            }
            if (counter === uniqueFiles.length) {
              this.globalLogger('treto')
              this.finishedUpload = true
              if (this.filesToArchive.length === 0) {
                this.loadingComponent.close()
                this.closeModal()
              } else if (this.finishedArchive) {
                this.globalLogger('finished archive e true vo upload')
                this.loadingComponent.close()
                this.closeModal()
              }
              if (isAdd) {
                for (let addLog in this.addedItemsLogs) {
                  this.globalLogger('add log: ', this.addedItemsLogs[addLog])
                  this.$analytics.logEvent('add_item', this.addedItemsLogs[addLog])
                }
              } else {
                for (let editLog in this.editedItemsLogs) {
                  this.globalLogger('edit log: ', this.editedItemsLogs[editLog])
                  this.$analytics.logEvent('edit_item', this.editedItemsLogs[editLog])
                }
                for (let addLogEdit in this.addedItemsEditLogs) {
                  this.globalLogger('add log edit: ', this.addedItemsEditLogs[addLogEdit])
                  this.$analytics.logEvent('add_item_edit_pl', this.addedItemsEditLogs[addLogEdit])
                }
                for (let deleteLog in this.deletedItemsLogs) {
                  this.globalLogger('IMA ZA UPLOAD')
                  this.globalLogger('delete log: ', this.deletedItemsLogs[deleteLog])
                  this.$analytics.logEvent('delete_item', this.deletedItemsLogs[deleteLog])
                }
              }
            }
          })
        }).catch(error => {
          this.globalLogger('Submit files error: ', error)
          let itemName = null
          let added = false
          for (let id in this.items) {
            if ((this.items[id].file && this.items[id].file.name === f.name) || this.items[id].resourceName === f.name) {
              itemName = this.items[id].name
              this.globalLogger(this.items[id].type, this.items[id].videoUrl)
              this.globalLogger('proverki', this.items[id].imageUrl)
              if ((this.items[id].type === 'video' && this.items[id].videoUrl === undefined) || ((this.items[id].type === 'image' || this.items[id].type === 'weather' || this.items[id].type === 'airquality' || this.items[id].type === 'clock' || this.items[id].type === 'arrivals' || this.items[id].type === 'departures' || this.items[id].type === 'rates') && (this.items[id].imageUrl === undefined || this.items[id].imageUrl === '')) || (this.items[id].type === 'pdf' && (this.items[id].pdfUrl === undefined || this.items[id].pdfUrl === ''))) {
                added = true
                this.items = this.items.filter((x) => { return this.items.indexOf(x) !== parseInt(id) })
                break
              }
            }
          }
          counter++
          this.globalLogger('counter: ', counter)
          this.globalLogger('cetvrto')
          this.loadingComponent.close()
          this.closeModal()
          let mess = null
          if (added) {
            mess = 'Item "' + itemName + '" is not added because file ' + f.name + ' is <b>too big</b>.'
          } else {
            mess = 'Item "' + itemName + '" is not updated because file ' + f.name + ' is <b>too big</b>.'
          }
          this.$buefy.dialog.alert({
            title: 'Upload failed',
            message: mess,
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }).finally(() => {
          this.globalLogger('FINALLY error')
          if (!this.getNotMigrated().includes(this.userId)) {
            this.$store.state.database.ref('/neoslide/playlists/' + this.workspaceId + '/' + this.playlistId).update({
              items: this.items
            })
          } else {
            this.$store.state.database.ref('/playlists/' + this.userId + '/' + this.playlistId).update({
              items: this.items
            })
          }
          this.globalLogger(this.items)
        })
      }
    },
    setItemImageUrl (item, url, id, fileName) {
      if (item.type === 'video') {
        if (!this.getNotMigrated().includes(this.userId)) {
          this.$store.state.database.ref('/neoslide/playlists/' + this.workspaceId + '/' + this.playlistId + '/items/' + id).update({
            resourceName: fileName,
            videoUrl: url
          })
        } else {
          this.$store.state.database.ref('/playlists/' + this.userId + '/' + this.playlistId + '/items/' + id).update({
            resourceName: fileName,
            videoUrl: url
          })
        }
      } else if (item.type === 'weather') {
        if (!this.getNotMigrated().includes(this.userId)) {
          this.$store.state.database.ref('/neoslide/playlists/' + this.workspaceId + '/' + this.playlistId + '/items/' + id).update({
            resourceName: fileName,
            weatherImageUrl: '',
            imageUrl: url
          })
        } else {
          this.$store.state.database.ref('/playlists/' + this.userId + '/' + this.playlistId + '/items/' + id).update({
            resourceName: fileName,
            weatherImageUrl: '',
            imageUrl: url
          })
        }
      } else {
        if (!this.getNotMigrated().includes(this.userId)) {
          this.$store.state.database.ref('/neoslide/playlists/' + this.workspaceId + '/' + this.playlistId + '/items/' + id).update({
            resourceName: fileName,
            imageUrl: url
          })
        } else {
          this.$store.state.database.ref('/playlists/' + this.userId + '/' + this.playlistId + '/items/' + id).update({
            resourceName: fileName,
            imageUrl: url
          })
        }
      }
    },
    cancelEdit () {
      if (this.editEnabled) {
        this.name = this.editStaticPlaylistRef.name
        this.items = [...this.editStaticPlaylistRef.items]
      }
      this.closeModal()
    },
    dragstart (payload) {
      this.draggingRow = payload.row
      this.draggingRowIndex = payload.index
      payload.event.dataTransfer.effectAllowed = 'copy'
    },
    dragover (payload) {
      payload.event.dataTransfer.dropEffect = 'copy'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    dragleave (payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    drop (payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      let droppedOnRowIndex = payload.index
      let temp = this.items[this.draggingRowIndex]
      this.items[this.draggingRowIndex] = this.items[droppedOnRowIndex]
      this.items[droppedOnRowIndex] = temp
      this.refreshItemsTable()
    },
    closeModal () {
      if (this.propParentFn) {
        this.propParentFn()
      }
      this.$parent.close()
    },
    storageAvailable () {
      this.globalLogger('Storage available')
      this.totalStorageSize = 0
      for (let menu in this.menus) {
        var sum = 0
        var menuRef = Object.assign({}, this.$store.getters.getMenu(menu))
        if (menuRef.items !== undefined) {
          var menuItems = [...menuRef.items.filter(x => x.resourceName !== '')]
          menuItems = menuItems.filter((v, i, a) => a.findIndex(v2 => (v2.resourceName === v.resourceName)) === i)
          var noResources = menuItems.length
          // this.numbersRes[playlist] = noResources
          if (noResources > 0) {
            for (let i = 0; i < menuItems.length; i++) {
              if (menuItems[i].resourceName !== '') {
                sum += menuItems[i].resourceSize
              }
            }
            this.totalStorageSize += sum
          }
          // this.totalPlaylistsSize
        }
      }
      // archive begin
      if (this.menusArchive !== null) {
        for (let i = 0; i < this.menusArchive.items.length; i++) {
          this.totalStorageSize += this.menusArchive.items[i].resSize
        }
      }
      if (this.playlistsArchive !== null) {
        for (let x = 0; x < this.playlistsArchive.items.length; x++) {
          this.totalStorageSize += this.playlistsArchive.items[x].resSize
        }
      }
      if (this.specialOffersArchive !== null) {
        for (let y = 0; y < this.specialOffersArchive.items.length; y++) {
          this.totalStorageSize += this.specialOffersArchive.items[y].resSize
        }
      }
      // archive end
      for (let playlist in this.playlists) {
        var sum1 = 0
        var playlistRef = Object.assign({}, this.$store.getters.getPlaylist(playlist))
        if (playlistRef.items !== undefined) {
          var playlistItems = [...playlistRef.items.filter(x => x.resourceName !== '')]
          playlistItems = playlistItems.filter((v, i, a) => a.findIndex(v2 => (v2.resourceName === v.resourceName)) === i)
          var noResources1 = playlistItems.length
          if (noResources1 > 0) {
            for (let i = 0; i < playlistItems.length; i++) {
              if (playlistItems[i].resourceName !== '') {
                sum1 += playlistItems[i].resourceSize
              }
            }
            this.totalStorageSize += sum1
          }
        }
      }
      for (let offer in this.specialOffers) {
        var sum2 = 0
        var offerRef = Object.assign({}, this.$store.getters.getSpecialOffer(offer))
        if (offerRef.items !== undefined) {
          var offerItems = [...offerRef.items.filter(x => x.resourceName !== '')]
          offerItems = offerItems.filter((v, i, a) => a.findIndex(v2 => (v2.resourceName === v.resourceName)) === i)
          var noResources2 = offerItems.length
          if (noResources2 > 0) {
            for (let i = 0; i < offerItems.length; i++) {
              if (offerItems[i].resourceName !== '') {
                sum2 += offerItems[i].resourceSize
              }
            }
            this.totalStorageSize += sum2
          }
        }
      }
      this.globalLogger('before: ', this.totalStorageSize)
      this.totalStorageSize -= this.sizesMinus
      this.globalLogger('after minus: ', this.totalStorageSize)
      this.totalStorageSize += this.sizesPlus
      this.globalLogger('after: ', this.totalStorageSize)
      this.globalLogger('ITEMI: ', this.items)
      return (this.totalStorageSize < 1073741824)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/playlists/PlaylistAddEdit.vue